var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#D00202",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595 1475 c-44 -12 -161 -44 -260 -70 -234 -61 -245 -67 -245 -132 0 -49 199 -773 224 -816 33 -55 437 -457 460 -457 37 0 81 39 354 312 350 352 336 307 157 488 -71 72 -125 134 -125 145 0 10 9 51 20 91 19 66 19 76 6 108 -16 39 -33 46 -250 102 -59 15 -113 33 -120 39 -6 6 -20 46 -30 89 -15 59 -26 83 -49 102 -34 29 -39 29 -142 -1z m135 -37 c9 -22 33 -110 160 -591 48 -181 51 -200 37 -214 -17 -17 -514 -153 -558 -153 -15 0 -31 6 -36 13 -11 13 -213 765 -213 791 0 27 40 43 225 91 99 26 207 55 240 65 87 26 133 26 145 -2z m374 -276 c41 -14 52 -22 54 -42 2 -20 -160 -645 -199 -767 -6 -18 -19 -35 -29 -38 -26 -8 -500 118 -500 133 0 4 42 18 93 31 284 72 413 111 430 132 23 29 22 51 -12 176 -62 228 -111 421 -111 436 0 13 17 11 112 -14 61 -17 134 -38 162 -47z m276 -527 c0 -31 -568 -595 -599 -595 -18 0 -72 48 -208 182 -101 101 -179 184 -174 186 5 2 117 -26 248 -62 131 -36 252 -66 269 -66 56 0 66 20 139 291 37 140 72 269 77 288 l10 34 119 -119 c73 -73 119 -126 119 -139z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet1);
export default __webpack_public_path__ + "static/media/vet-1.bf1699d8ed5f026e09b7dfacad7f44b5.svg";
export { ForwardRef as ReactComponent };